import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const hasModuleTBAI = store.getters['auth/hasTBAIModule']
  const hasModuleXslt = store.getters['auth/hasXsltModule']
  const hasModuleVeriFactu = store.getters['auth/hasVerifactuModule']
  const hasModuleOCRIntegration = store.getters['auth/hasOCRIntegrationModule']
  const hasModuleReceivedInvoice = store.getters['auth/hasReceivedInvoiceModule']
  const hasModuleRecobros = store.getters['auth/hasGeneratePaymentLinkModule']
  const hasOCRIAModule = store.getters['auth/hasOCRIAIntegrationModule']

  const recobroconfig = {
    name: i18n.t('companies.configuration_recobro.recobro_header'),
    path: 'companies/recobroconfig',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const reportconfig = {
    name: i18n.t('companies.send_verifactu_ticketBAI'),
    path: 'companies/reportconfig',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const bankaccount = {
    name: i18n.t('agenda.cuentas_bancarias'),
    path: 'companies/bankaccounts',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const pgeconfig = {
    name: i18n.t('companies.configuration_rec.dir_header'),
    path: 'companies/pgeconfig',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const apsconfig = {
    name: i18n.t('companies.configuration_aps.aps_header'),
    path: 'companies/apsconfig',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configPdftemplate = {
    name: i18n.t('plantilla_pdf.header'),
    path: 'companies/pdftemplate',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const historical = {
    name: i18n.t('historical.entity_name'),
    path: 'companies/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: []
  }

  const companiesMenu = {
    icon: 'companies',
    name: i18n.t('companies.header'),
    path: 'companies',
    use_parent_params: true,
    params_required: ['id'],
    registerNavFromMenu: false,
    sc: [
      {
        name: i18n.t('app.detail'),
        path: 'companies/detail',
        params,
        registerNavFromMenu: false,
        sc: [] // shorcuts
      },
      {
        name: i18n.t('companies.configuration.header'),
        path: 'companies/config',
        params,
        registerNavFromMenu: false,
        disabled: params.id === -1 || params.id === '-1',
        sc: [] // shorcuts
      }
    ]
  }

  if (hasModuleRecobros) {
    companiesMenu.sc.push(recobroconfig)
  }

  if (hasModuleTBAI || hasModuleVeriFactu) {
    companiesMenu.sc.push(reportconfig)
  }
  companiesMenu.sc.push(bankaccount)

  
  if (hasModuleReceivedInvoice) {
    companiesMenu.sc.push(pgeconfig)
    if (hasModuleOCRIntegration && !hasOCRIAModule) {
      companiesMenu.sc.push(apsconfig)
    }
  }
  if (hasModuleXslt) {
    companiesMenu.sc.push(configPdftemplate)
  }
  companiesMenu.sc.push(historical)
  return [
    companiesMenu
  ]
}
